<template lang="html">
  <Row :gutter="0">
    <Col :md="24" style="text-align: center">
      <br>
      <img src="/immagini/logo.png" height="150" style="background: rgba(255,255,255,1); box-shadow: 0 0 15px #ccc">
      <br>
    </Col>
    <Col :md="12">
      <Layout class="content-sm">
        <Content>
          <h2 style="margin-left: 112px">
            <Icon type="ios-settings"/>
            &nbsp;Impostazioni Account
          </h2>
          <br>
          <Form :label-width="140">
            <FormItem label="Email">
              <Input v-model="user_form.email"/>
            </FormItem>
            <FormItem label="Nome">
              <Input v-model="user_form.name"/>
            </FormItem>
            <FormItem label="Password">
              <Input type="password" v-model="user_form.password"/>
            </FormItem>
            <FormItem label="Conferma Password" :error="user_form.password != user_form.password_confirm ? 'Le password devono coincidere' : null">
              <Input type="password" v-model="user_form.password_confirm"/>
            </FormItem>
            <FormItem>
              <Button @click="saveUser()" :loading="loading">Salva</Button>
            </FormItem>
          </Form>
        </Content>
      </Layout>
      <br>
      <Layout class="content-sm">
        <Content>

          <div style="margin-left: 112px;">
            <br>
            <h2>
              <Icon type="ios-settings"/>
              &nbsp;Importazioni
            </h2>
            <br>
            Vai alla pagina per l'importazione dati <a @click="$router.push({name:'import'})">cliccando qui</a>
          </div>
          <br>
          <div style="margin-left: 112px; margin-top: 30px">
            <br>
            <h2>
              <Icon type="ios-settings"/>
              &nbsp;Cancellazione prima nota e fatture
            </h2>
            <br>
            <span>Digitare l'anno da eliminare (es. 2018):</span>
            <br>
            <NumInput v-model="drop_year"/>
            <Button @click="dropTransactions" :loading="dropping_txs" type="error">Elimina Prima nota</Button>
          </div>
          <br>
          <br>
        </Content>
      </Layout>
    </Col>

    <Col :md="12">
      <Layout class="content-sm">
        <Content>
          <h2 style="margin-left: 112px">
            <Icon type="ios-settings"/>
            &nbsp;Impostazioni Centro {{  }}
          </h2>
          <br>
          <SettingsCompany/>
        </Content>
      </Layout>
    </Col>
  </Row>
</template>

<script>

import SettingsCompany from './settings-company'
export default {
  components: {
    SettingsCompany,
  },
  data () {
    return {
      loading: false,
      user_form: this._.clone(this.$store.session.user),
      dropping_txs: false,
      drop_year: '',
    }
  },

  methods:{
    saveUser () {
      if (this.user_form.password != this.user_form.password_confirm) {
        this.$Message.error('Le password devono coincidere')
        return
      }
      this.loading = true
      this.$http.post("auth/me", this.user_form).then(res => {
        this.$Message.success('Salvato')
        this.$store.session.user = res.data
      }).finally(res => {
        this.loading = false
      })
    },

    dropTransactions () {
      if (!confirm('Questa operazione eliminerà tutte le transazioni presenti in prima nota, comprese le fatture')) {
        return
      }
      this.dropping_txs = true
      this.$http.post('drop-transactions/'+this.$store.company.id+'/'+this.drop_year).then(r => {
        alert('Eliminata prima nota')
      }).finally(() => {
        this.dropping_txs = false
      })
    }
  },
}
</script>

<style lang="css">
</style>
